import React, { useEffect, useState, useMemo, lazy, Suspense } from 'react';
import { NavLink } from 'react-router-dom';
import Slider from 'react-slick';
import AwardSection from '../components/AwardsSection';
import CourseDetail from '../components/HomePageData/course-detail';
import LazyWhenVisible from '../components/LazyWhenVisible';
import { DeferredIframe, DeferredVideo } from '../components/DeferredMedia';

const AnnualFunction = lazy(() => import('../components/Annualfunction'));
const CollaborationSliderHome = lazy(() => import('../components/CollaborationSlider'));
const GalleryData = lazy(() => import('../components/HomePageData/galleryHome'));
const InfiniteImageSlider = lazy(() => import('../components/InfiniteImageSlider'));

const FACEBOOK_KINJAL_WATCH = 'https://www.facebook.com/watch?v=2141945653257846';

const BRAND_LOGOS = [
  'images/brand-logo/RIS-01.svg',
  'images/brand-logo/RIS-02.svg',
  'images/brand-logo/RIS-03.svg',
  'images/brand-logo/RIS-04.svg',
  'images/brand-logo/RIS-05.svg',
  'images/brand-logo/RIS-06.svg',
  'images/brand-logo/RIS-07.svg',
  'images/brand-logo/RIS-08.svg',
  'images/brand-logo/RIS-09.svg',
];

const PARENT_IMAGES = [
  'images/parents/parents-1.png',
  'images/parents/parents-2.png',
  'images/parents/parents-3.png',
];

/** Instagram page/reel links must use /embed/ for iframes */
function getStudentSpeaksEmbedSrc(url) {
  if (!url || typeof url !== 'string') return url;
  const reel = url.match(/instagram\.com\/reel\/([^/?#]+)/i);
  if (reel && !url.includes('/embed')) {
    return `https://www.instagram.com/reel/${reel[1]}/embed/`;
  }
  const post = url.match(/instagram\.com\/p\/([^/?#]+)/i);
  if (post && !url.includes('/embed')) {
    return `https://www.instagram.com/p/${post[1]}/embed/`;
  }
  return url;
}

const STUDENT_SPEAKS_VIDEOS = [
  { name: 'Manvi Mishra', src: 'https://www.youtube.com/embed/3u42vNuCfr8?si=kqj5ypobNHG_9R2H' },
  { name: 'Somya', src: 'https://www.youtube.com/embed/XPAeR0J34fU?si=smHS0Xz0aK4kqL-F' },
  { name: 'Angel', src: 'https://www.youtube.com/embed/0JFXsolz_bY?si=su6iURzOS6QkVG6a' },
  { name: 'Aahana', src: 'https://www.youtube.com/embed/cW6kiXj3Sng?si=_SVlGUYv-GIbPZck' },
  {
    name: 'Kinjal Koundal',
    src: `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(FACEBOOK_KINJAL_WATCH)}&show_text=false&width=1280&height=720`,
  },
  {
    name: 'Anwita Jaitly',
    variant: 'instagramLink',
    href: 'https://www.instagram.com/reel/DXRYev3FWta/?utm_source=ig_web_copy_link&igsh=NTc4MTIwNjQ2YQ==',
    posterSrc: 'images/homepage/instagram-girl.png',
    iconSrc: 'images/homepage/inst-icon.svg',
  },
];

const MYRIAD_ITEMS = [
  {
    id: 'about',
    title: 'About',
    text: 'Nestled among the serene beauty of Dhauladhar, Rainbow International School stands as a beacon of excellence, nurturing minds and shaping Future.',
    image: 'images/homepage/principal.png',
    alt: 'about',
    colorChange: false,
  },
  {
    id: 'principalPopupatal',
    title: 'Atal Tinkering Lab/Robotics Innovation Hub',
    text: 'Through Robotics,we embark on a journey of innovation forging connection between technology and human ingenuity',
    image: 'images/homepage/lab.png',
    alt: 'about',
    colorChange: true,
    wrapImage: true,
    gallery: [
      'images/atal-images/2-IMG.JPG',
      'images/atal-images/3-IMG.JPG',
      'images/atal-images/4-IMG.JPG',
      'images/atal-images/6-IMG.JPG',
    ],
  },
  {
    id: 'principalPopupatalWeightlifting',
    title: 'Khelo India Residential Academy for Weightlifting',
    image: 'images/homepage/khalo.png',
    alt: 'about',
    colorChange: false,
    gallery: [
      'images/weightlifting/weightlifting-2.JPG',
      'images/weightlifting/weightlifting-4.JPG',
      'images/weightlifting/weightlifting-5.JPG',
      'images/weightlifting/weightlifting-6.JPG',
    ],
  },
  {
    id: 'principalPopupKhelo',
    title: 'Khelo India Residential Academy for Table-Tennis',
    image: 'images/homepage/tech.png',
    alt: 'about',
    colorChange: true,
    wrapImage: true,
    linkTo: '/table-tennis',
  },
  {
    id: 'principalPopupGymnastics',
    title: 'Gymnastics Academy',
    image: 'images/homepage/gym.png',
    alt: 'about',
    colorChange: false,
    wrapImage: true,
    gallery: [
      'images/gymnastics/4-GYM.jpg',
      'images/gymnastics/6-GYM.jpg',
      'images/gymnastics/7-GYM.jpg',
      'images/gymnastics/8-GYM.jpg',
    ],
  },
  {
    id: 'principalPopupCricket',
    title: 'Cricket Sub-Centre for HPCA Himachal Pradesh Cricket Association',
    image: 'images/homepage/ckt.png',
    alt: 'about',
    colorChange: true,
    gallery: [
      'images/cricket/cricket-1.jpg',
      'images/cricket/cricket-2.jpg',
      'images/cricket/cricket-3.jpg',
      'images/cricket/cricket-6.png',
    ],
  },
  {
    id: 'principalPopupEDUCO',
    title: 'German language EDUCO PREMIUM PARTNER SCHOOLS',
    image: 'images/homepage/student.png',
    alt: 'about',
    colorChange: false,
    gallery: [
      'images/EDUCO/EDUCO-1.jpg',
      'images/EDUCO/EDUCO-3.jpg',
      'images/EDUCO/EDUCO-4.JPG',
      'images/EDUCO/EDUCO-2.jpg',
    ],
  },
  {
    id: 'principalPopupCambridge',
    title: 'Cambridge Based Learning',
    image: 'images/homepage/cambridge.jpg',
    alt: 'cambridge',
    colorChange: true,
    linkTo: '/cambridge',
  },
  {
    id: 'principalPopupMicrosoft',
    title: 'Microsoft Showcase School',
    image: 'images/homepage/micr.png',
    alt: 'about',
    colorChange: false,
    gallery: [
      'images/microsoft/microsoft-1.png',
      'images/microsoft/microsoft-2.jpg',
      'images/microsoft/microsoft-3.jpeg',
      'images/microsoft/microsoft-4.jpg',
    ],
  },
  {
    id: 'principalPopupBritish',
    title: 'British Council',
    image: 'images/homepage/brit.png',
    alt: 'about',
    colorChange: true,
    gallery: [
      'images/british/british-2.jpg',
      'images/british/british-3.jpg',
      'images/british/british-4.jpg',
      'images/british/british-7.JPG',
    ],
  },
  {
    id: 'principalPopupHorse',
    title: 'Horse Riding',
    image: 'images/horse-riding/horse-riding-5.jpg',
    alt: 'riding',
    colorChange: false,
    gallery: [
      'images/horse-riding/horse-riding-1.jpg',
      'images/horse-riding/horse-riding-2.jpg',
      'images/horse-riding/horse-riding-3.jpg',
      'images/horse-riding/horse-riding-4.jpg',
    ],
  },
  {
    id: 'principalPopupSwimming',
    title: 'Swimming',
    image: 'images/swimming/2-swim.jpg',
    alt: 'about',
    colorChange: true,
    gallery: [
      'images/swimming/1-swim.JPG',
      'images/swimming/2-swim.jpg',
      'images/swimming/4-swim.JPG',
      'images/swimming/5-swim.JPG',
    ],
  },
  { id: 'spacer-1', spacer: true },
  {
    id: 'principalPopupSky',
    title: 'Sky Observatory',
    image: 'images/sky/sky-4.jpg',
    alt: 'about',
    colorChange: false,
    gallery: [
      'images/sky/sky-1.jpg',
      'images/sky/sky-2.jpg',
      'images/sky/sky-3.jpg',
      'images/sky/sky-5.jpg',
    ],
  },
  {
    id: 'principalPopuplabs',
    title: 'Anveshika Lab',
    image: 'images/homepage/Anveshika-Lab.png',
    alt: 'about',
    colorChange: true,
    gallery: [
      'images/lab/lab-1.jpg',
      'images/lab/lab-2.jpg',
      'images/lab/lab-3.jpg',
      'images/lab/lab-4.jpg',
    ],
  },
  { id: 'spacer-2', spacer: true },
];

function Modal({ isOpen, onClose, imageUrl }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <span className="close" onClick={onClose}>&times;</span>
        <img src={imageUrl} alt="modal" className="design-media-popup" />
      </div>
    </div>
  );
}

function Homepage() {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [popupOpen, setPopupOpen] = useState({});

  const openModal = (imageSrc) => {
    setSelectedImage(imageSrc);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const toggleFeaturePopup = (id) => {
    setPopupOpen((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  useEffect(() => {
    ['myVideo', 'parvaniVideo'].forEach((id) => {
      const videoElement = document.getElementById(id);
      if (videoElement) {
        videoElement.removeAttribute('controls');
      }
    });

    document.body.classList.add('homepage');
    return () => {
      document.body.classList.remove('homepage');
    };
  }, []);

  const studentSpeaksSliderSettings = useMemo(
    () => ({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4500,
      pauseOnHover: true,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      ],
    }),
    []
  );

  return (
    <div className="homepage new">
      <div className="banner-video">
        <video
          loop
          autoPlay
          muted
          playsInline
          preload="metadata"
          width="100%"
          height="900"
          id="myVideo"
          poster="images/banner-slider1.jpg"
        >
          <source src="video/hero-video-home-2022-fall.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="about-item">
        <div className="container mt-5">
          <div id="collapseOne" className="v-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#about">
            <div className="about-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="about-img">
                    <img src="images/homepage/about-new.png" alt="about" decoding="async" fetchPriority="high" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="about-new">
                    <span>GET TO KNOW US</span>
                    <h2 className="title-new">Rainbow International School</h2>
                    <p>
                      Rainbow International School, Nagrota Bagwan is one of the best schools in Himachal Pradesh, providing the highest quality and truly international standards of education. School holds firm in its belief that students do their best and teaching becomes productive when research is underlined as a criteria for scholarship, systematically guided by dedicated and quality teaching.
                    </p>
                  </div>
                  <div className="col-frames">
                    <NavLink className="nav-link" to="/teaching-staff">Read More</NavLink>
                    <NavLink className="nav-link" to="https://www.facebook.com/rainbowhimachal" target="_blank">Visit us</NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="awards_detail">
        <div className="container">
          <LazyWhenVisible minHeight={420} rootMargin="300px 0px">
            <AwardSection />
          </LazyWhenVisible>
        </div>
      </div>

      <div className="awards_detail chager-detail">
        <div className="container">
          <CourseDetail />
        </div>
      </div>

      <section className="myriad-section">
        <div className="container">
          <div className="myraid-heading">
            <h2 className="title-new">Myriad Colors of Rainbow</h2>
          </div>
          <div className="row myriad-col">
            {MYRIAD_ITEMS.map((item) => {
              if (item.spacer) {
                return <div className="col-md-3" key={item.id} />;
              }

              const boxClass = item.colorChange
                ? 'section-myraid-box colur-change'
                : 'section-myraid-box';

              const imageNode = (
                <img src={item.image} alt={item.alt} loading="lazy" decoding="async" />
              );

              const media = item.wrapImage ? <div className="among-code">{imageNode}</div> : imageNode;

              return (
                <div className="col-md-3" key={item.id}>
                  <div className={boxClass}>
                    {item.linkTo ? (
                      <NavLink to={item.linkTo} aria-label={item.title}>
                        {media}
                      </NavLink>
                    ) : item.gallery ? (
                      <a
                        href="#gallery"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleFeaturePopup(item.id);
                        }}
                      >
                        {media}
                      </a>
                    ) : (
                      imageNode
                    )}

                    {item.linkTo ? (
                      <NavLink to={item.linkTo} className="myriad-card-title-link">
                        <h3>{item.title}</h3>
                      </NavLink>
                    ) : (
                      <h3>{item.title}</h3>
                    )}
                    {item.text ? <p>{item.text}</p> : null}

                    {item.gallery && popupOpen[item.id] ? (
                      <div className="popup">
                        <div className="popup-content">
                          <span className="close" onClick={() => toggleFeaturePopup(item.id)}>&times;</span>
                          {item.gallery.map((src) => (
                            <img
                              key={src}
                              src={src}
                              alt=""
                              onClick={() => openModal(src)}
                            />
                          ))}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <LazyWhenVisible minHeight={300} rootMargin="250px 0px">
        <Suspense fallback={null}>
          <InfiniteImageSlider onImageClick={openModal} />
        </Suspense>
      </LazyWhenVisible>

      <div className="annual_function_ft">
        <div className="container">
          <LazyWhenVisible minHeight={360} rootMargin="280px 0px">
            <Suspense fallback={null}>
              <GalleryData />
            </Suspense>
          </LazyWhenVisible>
        </div>
      </div>

      <div className="annual_function_ft">
        <div className="container">
          <LazyWhenVisible minHeight={420} rootMargin="280px 0px">
            <Suspense fallback={null}>
              <AnnualFunction />
            </Suspense>
          </LazyWhenVisible>
        </div>
      </div>

      <div className="management-section">
        <div className="container">
          <div className="mangement-content">
            <h2 className="title-new">Management’s Desk</h2>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="principal-director">
                <img src="images/staff-images/principle3.jpg" alt="about" loading="lazy" decoding="async" />
              </div>
              <div className="management-heading">
                <h4>Director&apos;s Message</h4>
                <p>
                  At Rainbow, we believe in the transformation power of education. It is our collective mission to inspire and empower every individual who walks through our doors. As we navigate the ever-evolving landscape of learning, Our commitment to excellence remains unwavering.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="principal-director">
                <img src="images/homepage/Director.png" alt="about" loading="lazy" decoding="async" />
              </div>
              <div className="management-heading">
                <h4>Principal&apos;s Message</h4>
                <p>
                  Rainbow strives to become a benchmark of excellence in all vistas of education and is committed to prepare today&apos;s youth as confident, smart, solution - oriented young leaders of tomorrow. Working towards revolutionising education as part of New Education Policy, students learn discovery based, inquiry based and analysis based methods. The array of technologies boosts the understanding of concepts.  Our success lies in witnessing our students flourish with flying colours.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="banner-video">
        <DeferredVideo
          id="parvaniVideo"
          src="video/parvani-journey.mp4"
          loop
          autoPlay
          muted
          playsInline
          preload="metadata"
          poster="images/banner-slider2.jpg"
          width="100%"
          height="900"
        />
      </div>

      <div className="parents-thing">
        <div className="container">
          <div className="heading-parents">
            <h2 className="title-new">Student Speaks</h2>
          </div>
          <div className="student-speaks-slider">
            <Slider {...studentSpeaksSliderSettings}>
              {STUDENT_SPEAKS_VIDEOS.map((video, index) => (
                <div key={`${video.name}-${video.variant || index}`}>
                  <div className="design-parents-video">
                    <div className="testimonial-video">
                      {video.variant === 'instagramLink' ? (
                        <a
                          href={video.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="student-speaks-instagram-card"
                          aria-label={`${video.name} — open on Instagram`}
                        >
                          <div className="student-speaks-embed student-speaks-embed--poster">
                            <img
                              src={video.posterSrc}
                              alt=""
                              className="student-speaks-poster-img"
                              loading="lazy"
                              decoding="async"
                            />
                            <span className="student-speaks-ig-icon" aria-hidden="true">
                              <img src={video.iconSrc || 'images/homepage/Instagram.svg'} alt="" />
                            </span>
                          </div>
                        </a>
                      ) : (
                        <div className="student-speaks-embed">
                          <DeferredIframe
                            fill
                            src={getStudentSpeaksEmbedSrc(video.src)}
                            title={video.name}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                          />
                        </div>
                      )}
                    </div>
                    <h4>{video.name}</h4>
                    {video.caption ? <p>{video.caption}</p> : null}
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>

      <section className="parents-section">
        <div className="container">
          <div className="heading-parents">
            <h2 className="title-new">What Parents Think About School!</h2>
          </div>
          <div className="row">
            {PARENT_IMAGES.map((src) => (
              <div className="col-md-4" key={src}>
                <div className="testimonial-coder">
                  <img src={src} alt="view" loading="lazy" decoding="async" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="parents-thing">
        <div className="container">
          <div className="heading-parents">
            <h2 className="title-new">Parents speak</h2>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="design-parents-video">
                <div className="testimonial-video">
                  <DeferredIframe
                    width="100%"
                    height={410}
                    src="https://www.youtube.com/embed/LEEpR0chbOA"
                    title="PARENTS REVIEWS"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="design-parents-video">
                <div className="testimonial-video">
                  <DeferredIframe
                    width="100%"
                    height={410}
                    src="https://www.youtube.com/embed/bLkIMAY2jv8"
                    title="PARENTS REVIEWS.."
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="homepage-new-slider">
        <div className="container">
          <div className="heading-parents">
            <h2 className="title-new">Rainbow Alumni</h2>
          </div>
          <LazyWhenVisible minHeight={280} rootMargin="250px 0px">
            <Suspense fallback={null}>
              <CollaborationSliderHome />
            </Suspense>
          </LazyWhenVisible>
          <div className="alumni-viewmore">
            <NavLink className="nav-link" to="/alumni">View More</NavLink>
          </div>
        </div>
      </div>

      <div className="Collaboration">
        <div className="heading-parents">
          <h2 className="title-new">In Collaboration with</h2>
        </div>
        <div className="row design-parents-video">
          {BRAND_LOGOS.map((src) => (
            <div className="slider-pret" key={src}>
              <img src={src} alt="RIS" loading="lazy" decoding="async" />
            </div>
          ))}
        </div>
      </div>

      <Modal isOpen={modalOpen} onClose={closeModal} imageUrl={selectedImage} />
    </div>
  );
}

export default Homepage;
